import React from "react";
import "./index.less";

export default function DeskTop(props) {
  return (
    <div className="desktop" ref={props.ref}>
      <div className="desktopContent">
        <div className="linkWrap">
          <div className="linkItem">Request Price</div>
          <div className="linkItem">Brochure Download</div>
        </div>
      </div>
    </div>
  );
}
